let priceUrlParam = '' //used to fix ranged price filtering

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapper');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    // Update Collection Gender Tabs by URL
    const url = new URLSearchParams(searchParams);
    const productTypes = url.getAll('filter.p.product_type');
    const filterGendersTabsAll = document.querySelectorAll('.collection-tabs__filters.filter--genders');

    if(!filterGendersTabsAll) return;

    filterGendersTabsAll.forEach((filterGendersTabsItem) => {
      const filterGenders = filterGendersTabsItem.querySelectorAll('.item');
      filterGenders.forEach((filterGender) => {
        const filterGenderDataType = filterGender.dataset.filter;
        if(productTypes && productTypes.length > 0) {
          if (productTypes.includes(filterGenderDataType)) {
            filterGender.classList.add('active');
          } else {
            filterGender.classList.remove('active');
          }
        } else {
          if(filterGenderDataType === 'all') {
            filterGender.classList.add('active');
          } else {
            filterGender.classList.remove('active');
          }
        }
      });
    });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const newProductCount = parsedHTML.querySelector('#ProductCount');
    const currentProductCount = document.querySelector('#ProductCount');
    
    const newProductGrid = parsedHTML.querySelector('#product-grid');
    const currentProductGrid = document.querySelector('#product-grid');
    
    if (newProductCount && currentProductCount) {
      currentProductCount.innerHTML = newProductCount.innerHTML;
    }
    
    if (newProductGrid && currentProductGrid) {
      currentProductGrid.innerHTML = newProductGrid.innerHTML;

      currentProductGrid.classList.add('pageOne');
      currentProductGrid.dataset.pages = newProductGrid.dataset.pages;
    }

    // Update filter products number
    const filterProductsNumber = document.getElementById('filter-products-count');
    if (filterProductsNumber) {
      filterProductsNumber.innerText = newProductCount.dataset.productsCount;
    }

    // Update product reviews widgets
    yotpoWidgetsContainer.initWidgets();

    setTimeout(()=>{
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      if (typeof initializeScrollZoomAnimationTrigger === 'function') initializeScrollZoomAnimationTrigger(html.innerHTML); 
    },10);

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    // Extra - Apply Price Range Slider
    extraFiltersSettings.applyPriceRangeSlider();
    extraFiltersSettings.updateFiltersCount();
  }

  static renderActiveFacets(html) {
    const activeFacets = '.active-facets';

    const activeFacetsElement = html.querySelector(activeFacets);
    if (!activeFacetsElement) return;
    document.querySelector(activeFacets).innerHTML = activeFacetsElement.innerHTML;

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    sortFilterForms.forEach((form) => {
      const noJsElements = document.querySelectorAll('.no-js-list');
      noJsElements.forEach((el) => el.remove());

      let urlParams = this.createSearchParams(form);

      if (!urlParams) return;
      if (urlParams === 'sort_by=manual') return;

      if (urlParams.includes('price')) {
        const priceMinParam = 'filter.v.price.gte';
        const priceMaxParam = 'filter.v.price.lte';
        
        const searchParams = new URLSearchParams(urlParams);

        const priceMin = searchParams.get(priceMinParam);
        const priceMax = searchParams.get(priceMaxParam);
  
        if (priceMin === '') searchParams.delete(priceMinParam);
        if (priceMax === '') searchParams.delete(priceMaxParam);
  
        if (![...searchParams].length) return;

        urlParams = searchParams.toString();
      }

      forms.push(urlParams);
    });

    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

//custom dossier logic
class ExtraFiltersSettings {
  init() {
    this.filtersWrapper = document.querySelector('.CAT__filters');
    this.filtersAction = document.querySelector('.CAT__filters-action');
    this.filtersActionButton = this.filtersAction.querySelector('.dossier-filter-button');
    this.filtersCloseButton = this.filtersWrapper.querySelector('.close-icon');
    this.filtersToggleButtons = this.filtersWrapper.querySelectorAll('.dossier-filter-button');
    this.toggleClassName = 'open';
    this.activeFacetsClass = 'has-active-facets';


    this.toggleDossierFilter();
    this.toggleDossierSort();
    this.changeDossierSortTitle();
    this.applyPriceRangeSlider();
    this.updateFiltersCount();
  }

  toggleDossierFilter() {
    if (!this.filtersWrapper || !this.filtersActionButton || !this.filtersCloseButton || !this.filtersToggleButtons) return;
  
    const toggleFiltersElementsClass = () => {
      this.filtersActionButton.classList.toggle(this.toggleClassName);
      this.filtersWrapper.classList.toggle(this.toggleClassName);
    };
  

    if (!this.filtersActionButton._listenerAdded) {
      this.filtersActionButton.addEventListener('click', toggleFiltersElementsClass);
      this.filtersActionButton._listenerAdded = true;
    }

    this.filtersCloseButton.addEventListener('click', toggleFiltersElementsClass);
    this.filtersToggleButtons.forEach((toggleButton) => {toggleButton.addEventListener('click', toggleFiltersElementsClass)});

    if(this.filtersActionButton.classList.contains(this.toggleClassName)) {
      this.filtersWrapper.classList.add(this.toggleClassName);
    }
  }

  toggleDossierSort() {
    let container = document.querySelector('.dossier-sort__modal');
    let openButton = document.querySelector(".dossier-sort__button");

    if (openButton) {
      openButton.addEventListener('click', (e) => {
        // Prevent the click inside the button from propagating to the document
        e.stopPropagation();
        e.currentTarget.classList.toggle('open');
        container.classList.toggle('open');
      })
    }
  }

  changeDossierSortTitle() {
    let container = document.querySelector('.dossier-sort__modal');
    if (container) {
      container.addEventListener('click', (e) => {
        if (e.target.matches('label')) {
          let newValue = e.target.textContent.trim();
          let selectedOption = document.querySelector('.dossier-sort__selected-option');
          if (selectedOption) {
            selectedOption.innerText = newValue;
          }
        }
      });
    }
  }

  applyPriceRangeSlider() {
    var priceSlider = document.getElementById('price-slider');
    if (!priceSlider) return;

    function roundUpToNiceNumber(num) {
      return Math.ceil(num / 100) * 100;
    }

    const minInput = document.querySelector('.filter__min_value');
    const maxInput = document.querySelector('.filter__max_value');

    const minPrice = parseInt(minInput.min);
    const maxPrice = roundUpToNiceNumber(parseInt(maxInput.max));

    const step = Math.ceil((maxPrice - minPrice) / 5); // max 5 steps

    noUiSlider.create(priceSlider, {
      start: [
        minInput.value ? parseInt(minInput.value) : minPrice,
        maxInput.value ? parseInt(maxInput.value) : maxPrice
      ],
      margin: step,
      connect: true,
      range: {
        min: minPrice,
        max: maxPrice
      },
      step: step,
      tooltips: [true, true],
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return Number(value);
        }
      }
    });

    priceSlider.noUiSlider.on('change', function (values) {
      minInput.value = Math.round(values[0]);
      maxInput.value = Math.round(values[1]);
    
      const filterForm = document.querySelector('.facets__form');
      if (filterForm) {
        filterForm.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

    minInput.addEventListener('change', function () {
      priceSlider.noUiSlider.set([this.value || 0, null]);
    });
    maxInput.addEventListener('change', function () {
      priceSlider.noUiSlider.set([null, this.value || maxPrice]);
    });
  }

  updateFiltersCount() {
    const mainCollectionFilters = document.getElementById('main-collection-filters');
    const facetRemoveItems = document.querySelectorAll('.facet-remove__item');
    const filtersCount = document.querySelectorAll('.filters-count');
  
    if (!mainCollectionFilters) return;
  
    const activeCount = facetRemoveItems.length;
    filtersCount.forEach(item => item.textContent = activeCount);
    
    if (activeCount > 0) {
      mainCollectionFilters.classList.add(this.activeFacetsClass);
    } else {
      mainCollectionFilters.classList.remove(this.activeFacetsClass);
    }
  }

  closeFilter() {
    this.filtersActionButton.classList.remove(this.toggleClassName);
    this.filtersWrapper.classList.remove(this.toggleClassName);
  }
}

const extraFiltersSettings = new ExtraFiltersSettings();
extraFiltersSettings.init();